import { dialogDefault, OPEN_DIALOG, CLOSE_DIALOG } from "../consts";

const mydialog = {...dialogDefault}

export const openThisDialog = id => ({
    type: OPEN_DIALOG,
    payload: { open : true, id : id }
});

export const closeThisDialog = () => ({
    type: CLOSE_DIALOG,
    payload: {...dialogDefault}
});

export default function dialogReducer(state = mydialog, { type, payload }) {
    const actions = {
        [OPEN_DIALOG] : () => ({...state, ...payload }),
        [CLOSE_DIALOG] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}